<script setup lang="ts">
import { ref, shallowRef, computed, onMounted, onUnmounted, type Component } from "vue"
import { assign_job_to_user } from "../utils"
import DescriptionItem from "./JobList/Description.vue"
import CardItem from "./JobList/CardItem.vue"

defineProps<{ jobs: any[] }>()

const selectedJob = ref<any>(null)
const dynamicComponent = shallowRef<Component | null>(null)
const isMobileView = ref(window.matchMedia("(max-width: 768px)").matches)

let mediaQuery: MediaQueryList

function handleMediaChange(e: MediaQueryListEvent) {
  isMobileView.value = e.matches
}

onMounted(() => {
  mediaQuery = window.matchMedia("(max-width: 768px)")
  mediaQuery.addEventListener("change", handleMediaChange)
})

onUnmounted(() => {
  mediaQuery.removeEventListener("change", handleMediaChange)
})

function loadJobDescription(job: any) {
  selectedJob.value = job
  dynamicComponent.value = DescriptionItem
}

async function selectJobToMatch(job: any) {
  await assign_job_to_user(job)
  job.matched = !job.matched
}

function clearSelection() {
  selectedJob.value = null
  dynamicComponent.value = null
}
</script>

<style scoped>
.job-sidebar {
  max-height: 75rem;
  overflow: auto;
  scroll-behavior: smooth;
}

@media (max-width: 768px) {
  .job-sidebar {
    max-height: none;
  }
}

.cell {
  margin-bottom: 0.75rem;
}
</style>

<template>
    <div class="columns">
        <div
v-show="!isMobileView || !selectedJob"
role="region"
aria-label="Job filters"
class="column is-one-third job-sidebar">
            <div
v-for="job in jobs"
:key="job.id"
class="cell">
                <CardItem
                    :job=job
                    @load_job_description="loadJobDescription"
                    @select_job_to_match="selectJobToMatch"
                ></CardItem>
            </div>
        </div>
        <div v-show="!isMobileView || !!selectedJob" class="column">
            <button
v-if="isMobileView && selectedJob"
class="button is-light mb-4"
aria-label="Back to results"
@click="clearSelection">
              <i class="fas fa-arrow-left" aria-hidden="true"></i>
              <span class="is-sr-only">Back to results</span>
            </button>
            <component
                :is="dynamicComponent"
                v-if="dynamicComponent"
                :key="selectedJob.matched"
                :job="selectedJob"
                @select_job_to_match="selectJobToMatch"
            />
        </div>
    </div>
</template>
